import {CATEGORY_NAME, POST_TYPE_NAME} from '../utility/constants';

const bulkUpdatePostMicrositeDefaultState = {
  data: [],
  singlePost: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null,
  bulkSuccessMessage: '',
  bulkError: null
};

const bulkUpdatePostMicrositeReducer = (state = bulkUpdatePostMicrositeDefaultState, action) => {
  switch(action.type) {
    case 'RESET_BULK_UPDATE_POST_MICROSITE_NOTIFICATIONS':
      return {
        loading: false,
        error: false,
        bulkError: false,
        successMessage: '',
        errorMessage: '',
        bulkSuccessMessage: '',
      };
    case 'SHOW_BULK_UPDATE_POST_MICROSITE_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        bulkError: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    case 'BULK_UPDATE_POST_MICROSITE_SUCCESS':
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
        bulkError: null,
        bulkSuccessMessage: 'Bulk Update Success',
      };  
    default:
      return state;
  }
};

export default bulkUpdatePostMicrositeReducer;
